import {Container, Graphics, isMobile, Sprite, Texture} from "pixi.js";
import {isHorizontalScreen, universalClick} from "../utilites";
import {pixiComponents} from "../index";
import {store} from "../store";
import {getOtherGames} from "../api";
import * as PIXI from "pixi.js";
import {gsap} from "gsap";

export class OtherGamesSection {
    bannersPixiContainer = new Container();
    transparentBackground = new Graphics();

    constructor(pixiParent) {
        this.pixiParent = pixiParent;
        this.createTransparentBackground();
        this.createOpeningButton();
        this.createBannersSection();
        this.updateComponentsMetrics();
    }

    createBannersSection = async () => {
        this.banners = await getOtherGames(store.gameId);
        const bannerSize = {w: 190, h: 121, m: 5};

        const clickGameBannersEvent = new CustomEvent('clickGameBanners', {
            detail: {
                message: 'Game banner clicked!'
            }
        });

        const containerBackground = new Graphics();
        containerBackground.beginFill("rgba(0,0,0,0.7)");
        containerBackground.drawRect(0, 0, bannerSize.w + (bannerSize.m * 2), (bannerSize.h * 3) + (bannerSize.m * 4));
        containerBackground.endFill();
        this.bannersPixiContainer.addChild(containerBackground);

        this.banners.forEach((banner, index) => {
            PIXI.Assets.load(banner.image).then(() => {
                const bannerSprite = new Sprite(Texture.from(banner.image));
                bannerSprite.anchor.set(0.5, 0);
                bannerSprite.width = 190;
                bannerSprite.height = 121;
                bannerSprite.position.set(this.bannersPixiContainer.width / 2, (index * (bannerSize.h + bannerSize.m)) + bannerSize.m);

                bannerSprite.cursor = "pointer";
                bannerSprite.eventMode = "static";
                universalClick(bannerSprite, () => {
                    window.dispatchEvent(clickGameBannersEvent);
                    window.parent.postMessage({
                        event: 'open-game',
                        data: {id: banner.id}
                    }, '*');
                });

                this.bannersPixiContainer.addChild(bannerSprite);
            })
        });

        this.bannersPixiContainer.pivot.set(0, this.bannersPixiContainer.height / 2);
        this.bannersPixiContainer.x = -this.bannersPixiContainer.width;
        this.pixiParent.addChild(this.bannersPixiContainer);
    }

    createTransparentBackground() {
        this.transparentBackground.beginFill("rgba(0,0,0,0.01)");
        this.transparentBackground.drawRect(0, 0, 1500, 1500);
        this.transparentBackground.endFill();
        this.transparentBackground.eventMode = "static";
        universalClick(this.transparentBackground, () => this.close());

        this.pixiParent.addChild(this.transparentBackground);
    }

    createOpeningButton() {
        this.buttonSprite = new Sprite(Texture.from('./assets/singleIcons/openFromLeft.webp'));
        this.buttonSprite.anchor.set(0, 0.5);
        this.pixiParent.addChild(this.buttonSprite);
        this.buttonSprite.cursor = "pointer";
        this.buttonSprite.eventMode = "static";
        this.transparentBackground.visible = false;
        universalClick(this.buttonSprite, () => this.open());
    }

    open() {
        this.transparentBackground.visible = true;
        gsap.to(this.bannersPixiContainer, {
            x: 0,
            duration: 0.2,
        })
    }

    close() {
        this.transparentBackground.visible = false;
        gsap.to(this.bannersPixiContainer, {
            x: -this.bannersPixiContainer.width,
            duration: 0.2,
        })
    }

    updateComponentsMetrics() {
        this.buttonSprite.visible = store.lobbyEnabled;

        if (!isMobile.phone) {
            this.buttonSprite.position.y = pixiComponents.app.screen.height * 0.5;
            this.bannersPixiContainer.position.y = pixiComponents.app.screen.height * 0.5;
            return;
        }

        if (!isHorizontalScreen()) {
            this.buttonSprite.position.y = pixiComponents.app.screen.height * 0.83;
            this.bannersPixiContainer.position.y = pixiComponents.app.screen.height * 0.66;
        } else {
            this.buttonSprite.position.y = pixiComponents.app.screen.height * 0.5;
            this.bannersPixiContainer.position.y = pixiComponents.app.screen.height * 0.5;
        }

    }
}